<script>
const { VUE_APP_API_HOST } = process.env

export default {
  methods: {
    readAccount(id){
      return this.$http
        .get(`${VUE_APP_API_HOST}/accounts/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then(res => res, err => err)
    },

    updateAccount(account){
      return this.$http
        .put(`${VUE_APP_API_HOST}/accounts/${account.id}`,
          account,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then(res => res, err => err)
    },  

    update(profile){
      return this.$http
        .put(`${VUE_APP_API_HOST}/users/${profile.id}`,
          profile,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then(res => res, err => err)
    }, 
    
    updateUser(profile){
      let formData = new FormData()
      for(let [key, value] of Object.entries(profile)) {
        if(key == 'avatar' && value && typeof value == 'object') {
          formData.append('file', value)
        } else if (typeof value == 'object' && Array.isArray(value)) {
          if (value.length == 0) formData.append(key,null);
          value.forEach(v => {
            formData.append(key+'[]', v)
          });
        }else 
          formData.append(key, value)
      }
    
      return this.$http
        .put(`${VUE_APP_API_HOST}/users/${profile.id}`,
          // profile,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then(res => res, err => err)
    },   

    new(profile){
      return this.$http
        .post(`${VUE_APP_API_HOST}/users/`,
          profile,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then(res => res, err => err)
    }, 

    createUser(profile){
    
      return this.$http
        .post(`${VUE_APP_API_HOST}/users/`,
          profile,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then(res => res, err => err)
    },   

    list(body){
      return this.$http
        .get(`${VUE_APP_API_HOST}/users`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`}
          },
          {body}
        )
        .then(res => res, err => err)
    },

    listUsers(body){
      return this.$http
        .get(`${VUE_APP_API_HOST}/users`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`}
          },
          {body}
        )
        .then(res => res, err => err)
    },

    delete(id){
      return this.$http
        .delete(`${VUE_APP_API_HOST}/users/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },

    removeUser(id){
      return this.$http
        .delete(`${VUE_APP_API_HOST}/users/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },

    reset(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/auth/reset`,
          body,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then(res => res, err => err)
    },
    
    resetPassword(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/auth/reset`,
          body,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then(res => res, err => err)
    }
  }
}
</script>